export default 'vehicles';
